// extracted by mini-css-extract-plugin
export var bounce = "_p8-1";
export var generatingText = "_p8-6";
export var lightning = "_p8-4";
export var popup = "_p8-5";
export var progressBar = "_p8-7";
export var progressFill = "_p8-8";
export var progressShimmer = "_p8-9";
export var progressText = "_p8-a";
export var shimmer = "_p8-3";
export var uploadIcon = "_p8-0";
export var uploadingText = "_p8-2";